export default __webpack_public_path__ + "static/media/sonkyo_trac.442de2e5.png";